export const palletTopLeftApproach = (
  <g transform="scale(0.55) translate(0, 0)">
    {/* Outer border */}
    <rect
      x="1"
      y="0.5"
      width="49"
      height="47"
      rx="4.5"
      fill="none"
      stroke="currentColor"
      strokeOpacity="0.25"
    />
    {/* Top-left corner highlighted (orange) */}
    <rect x="4.5" y="4" width="19" height="18" rx="5" fill="currentColor" />
    {/* Top-right corner - arrow pointing to top-left */}
    <rect
      x="27.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M40.7929 18.7071C41.1834 19.0976 41.8166 19.0976 42.2071 18.7071C42.5976 18.3166 42.5976 17.6834 42.2071 17.2929L40.7929 18.7071ZM31.6005 7.10051C31.0482 7.1005 30.6005 7.54822 30.6005 8.10051L30.6005 17.1005C30.6005 17.6528 31.0482 18.1005 31.6005 18.1005C32.1528 18.1005 32.6005 17.6528 32.6005 17.1005L32.6005 9.1005L40.6005 9.10051C41.1528 9.10051 41.6005 8.65279 41.6005 8.10051C41.6005 7.54822 41.1528 7.10051 40.6005 7.10051L31.6005 7.10051ZM41.5 18L42.2071 17.2929L32.3076 7.3934L31.6005 8.10051L30.8934 8.80761L40.7929 18.7071L41.5 18Z"
      fill="white"
    />
    {/* Bottom-left corner - arrow pointing to top-left */}
    <rect
      x="4.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M17.7929 40.7071C18.1834 41.0976 18.8166 41.0976 19.2071 40.7071C19.5976 40.3166 19.5976 39.6834 19.2071 39.2929L17.7929 40.7071ZM8.60051 29.1005C8.04822 29.1005 7.6005 29.5482 7.60051 30.1005L7.60051 39.1005C7.60051 39.6528 8.04822 40.1005 8.60051 40.1005C9.15279 40.1005 9.60051 39.6528 9.60051 39.1005L9.6005 31.1005L17.6005 31.1005C18.1528 31.1005 18.6005 30.6528 18.6005 30.1005C18.6005 29.5482 18.1528 29.1005 17.6005 29.1005L8.60051 29.1005ZM18.5 40L19.2071 39.2929L9.30761 29.3934L8.60051 30.1005L7.8934 30.8076L17.7929 40.7071L18.5 40Z"
      fill="white"
    />
    {/* Bottom-right corner - arrow pointing to top-left */}
    <rect
      x="27.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M40.7929 40.7071C41.1834 41.0976 41.8166 41.0976 42.2071 40.7071C42.5976 40.3166 42.5976 39.6834 42.2071 39.2929L40.7929 40.7071ZM31.6005 29.1005C31.0482 29.1005 30.6005 29.5482 30.6005 30.1005L30.6005 39.1005C30.6005 39.6528 31.0482 40.1005 31.6005 40.1005C32.1528 40.1005 32.6005 39.6528 32.6005 39.1005L32.6005 31.1005L40.6005 31.1005C41.1528 31.1005 41.6005 30.6528 41.6005 30.1005C41.6005 29.5482 41.1528 29.1005 40.6005 29.1005L31.6005 29.1005ZM41.5 40L42.2071 39.2929L32.3076 29.3934L31.6005 30.1005L30.8934 30.8076L40.7929 40.7071L41.5 40Z"
      fill="white"
    />
  </g>
);

export const palletTopRightApproach = (
  <g transform="scale(0.55) translate(0, 0)">
    {/* Outer border */}
    <rect
      x="1"
      y="0.5"
      width="49"
      height="47"
      rx="4.5"
      fill="none"
      stroke="currentColor"
      strokeOpacity="0.25"
    />
    {/* Top-left corner - arrow pointing to top-right */}
    <rect
      x="4.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M9.30769 18.7071C8.91717 19.0976 8.284 19.0976 7.89348 18.7071C7.50295 18.3166 7.50295 17.6834 7.89348 17.2929L9.30769 18.7071ZM18.5001 7.10051C19.0524 7.1005 19.5001 7.54822 19.5001 8.10051L19.5001 17.1005C19.5001 17.6528 19.0524 18.1005 18.5001 18.1005C17.9478 18.1005 17.5001 17.6528 17.5001 17.1005L17.5001 9.1005L9.50008 9.10051C8.9478 9.10051 8.50008 8.65279 8.50008 8.10051C8.50008 7.54822 8.9478 7.10051 9.50008 7.10051L18.5001 7.10051ZM8.60059 18L7.89348 17.2929L17.793 7.3934L18.5001 8.10051L19.2072 8.80761L9.30769 18.7071L8.60059 18Z"
      fill="white"
    />
    {/* Top-right corner highlighted (orange) */}
    <rect x="27.5" y="4" width="19" height="18" rx="5" fill="currentColor" />
    {/* Bottom-left corner - arrow pointing to top-right */}
    <rect
      x="4.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M9.30769 40.7071C8.91717 41.0976 8.284 41.0976 7.89348 40.7071C7.50295 40.3166 7.50295 39.6834 7.89348 39.2929L9.30769 40.7071ZM18.5001 29.1005C19.0524 29.1005 19.5001 29.5482 19.5001 30.1005L19.5001 39.1005C19.5001 39.6528 19.0524 40.1005 18.5001 40.1005C17.9478 40.1005 17.5001 39.6528 17.5001 39.1005L17.5001 31.1005L9.50008 31.1005C8.9478 31.1005 8.50008 30.6528 8.50008 30.1005C8.50008 29.5482 8.9478 29.1005 9.50008 29.1005L18.5001 29.1005ZM8.60059 40L7.89348 39.2929L17.793 29.3934L18.5001 30.1005L19.2072 30.8076L9.30769 40.7071L8.60059 40Z"
      fill="white"
    />
    {/* Bottom-right corner - arrow pointing to top-right */}
    <rect
      x="27.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M32.3077 40.7071C31.9172 41.0976 31.284 41.0976 30.8935 40.7071C30.503 40.3166 30.503 39.6834 30.8935 39.2929L32.3077 40.7071ZM41.5001 29.1005C42.0524 29.1005 42.5001 29.5482 42.5001 30.1005L42.5001 39.1005C42.5001 39.6528 42.0524 40.1005 41.5001 40.1005C40.9478 40.1005 40.5001 39.6528 40.5001 39.1005L40.5001 31.1005L32.5001 31.1005C31.9478 31.1005 31.5001 30.6528 31.5001 30.1005C31.5001 29.5482 31.9478 29.1005 32.5001 29.1005L41.5001 29.1005ZM31.6006 40L30.8935 39.2929L40.793 29.3934L41.5001 30.1005L42.2072 30.8076L32.3077 40.7071L31.6006 40Z"
      fill="white"
    />
  </g>
);

export const palletBottomLeftApproach = (
  <g transform="scale(0.55) translate(0, 0)">
    {/* Outer border */}
    <rect
      x="1"
      y="0.5"
      width="49"
      height="47"
      rx="4.5"
      fill="none"
      stroke="currentColor"
      strokeOpacity="0.25"
    />
    {/* Top-left corner - arrow pointing to bottom-left */}
    <rect
      x="4.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M17.7929 7.39348C18.1834 7.00295 18.8166 7.00295 19.2071 7.39348C19.5976 7.784 19.5976 8.41717 19.2071 8.80769L17.7929 7.39348ZM8.60051 19.0001C8.04822 19.0001 7.6005 18.5524 7.60051 18.0001L7.60051 9.00008C7.60051 8.4478 8.04822 8.00008 8.60051 8.00008C9.15279 8.00008 9.60051 8.4478 9.60051 9.00008L9.6005 17.0001L17.6005 17.0001C18.1528 17.0001 18.6005 17.4478 18.6005 18.0001C18.6005 18.5524 18.1528 19.0001 17.6005 19.0001L8.60051 19.0001ZM18.5 8.10059L19.2071 8.80769L9.30761 18.7072L8.60051 18.0001L7.8934 17.293L17.7929 7.39348L18.5 8.10059Z"
      fill="white"
    />
    {/* Top-right corner - arrow pointing to bottom-left */}
    <rect
      x="27.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M40.7929 7.39348C41.1834 7.00295 41.8166 7.00295 42.2071 7.39348C42.5976 7.784 42.5976 8.41717 42.2071 8.80769L40.7929 7.39348ZM31.6005 19.0001C31.0482 19.0001 30.6005 18.5524 30.6005 18.0001L30.6005 9.00008C30.6005 8.4478 31.0482 8.00008 31.6005 8.00008C32.1528 8.00008 32.6005 8.4478 32.6005 9.00008L32.6005 17.0001L40.6005 17.0001C41.1528 17.0001 41.6005 17.4478 41.6005 18.0001C41.6005 18.5524 41.1528 19.0001 40.6005 19.0001L31.6005 19.0001ZM41.5 8.10059L42.2071 8.80769L32.3076 18.7072L31.6005 18.0001L30.8934 17.293L40.7929 7.39348L41.5 8.10059Z"
      fill="white"
    />
    {/* Bottom-left corner highlighted (orange) */}
    <rect x="4.5" y="26" width="19" height="18" rx="5" fill="currentColor" />
    {/* Bottom-right corner - arrow pointing to bottom-left */}
    <rect
      x="27.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M40.7929 29.3935C41.1834 29.003 41.8166 29.003 42.2071 29.3935C42.5976 29.784 42.5976 30.4172 42.2071 30.8077L40.7929 29.3935ZM31.6005 41.0001C31.0482 41.0001 30.6005 40.5524 30.6005 40.0001L30.6005 31.0001C30.6005 30.4478 31.0482 30.0001 31.6005 30.0001C32.1528 30.0001 32.6005 30.4478 32.6005 31.0001L32.6005 39.0001L40.6005 39.0001C41.1528 39.0001 41.6005 39.4478 41.6005 40.0001C41.6005 40.5524 41.1528 41.0001 40.6005 41.0001L31.6005 41.0001ZM41.5 30.1006L42.2071 30.8077L32.3076 40.7072L31.6005 40.0001L30.8934 39.293L40.7929 29.3935L41.5 30.1006Z"
      fill="white"
    />
  </g>
);

export const palletBottomRightApproach = (
  <g transform="scale(0.55) translate(0, 0)">
    {/* Outer border */}
    <rect
      x="1"
      y="0.5"
      width="49"
      height="47"
      rx="4.5"
      fill="none"
      stroke="currentColor"
      strokeOpacity="0.25"
    />
    {/* Top-left corner - arrow pointing to bottom-right */}
    <rect
      x="4.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M9.30769 7.39348C8.91717 7.00295 8.284 7.00295 7.89348 7.39348C7.50295 7.784 7.50295 8.41717 7.89348 8.80769L9.30769 7.39348ZM18.5001 19.0001C19.0524 19.0001 19.5001 18.5524 19.5001 18.0001L19.5001 9.00008C19.5001 8.4478 19.0524 8.00008 18.5001 8.00008C17.9478 8.00008 17.5001 8.4478 17.5001 9.00008L17.5001 17.0001L9.50008 17.0001C8.9478 17.0001 8.50008 17.4478 8.50008 18.0001C8.50008 18.5524 8.9478 19.0001 9.50008 19.0001L18.5001 19.0001ZM8.60059 8.10059L7.89348 8.80769L17.793 18.7072L18.5001 18.0001L19.2072 17.293L9.30769 7.39348L8.60059 8.10059Z"
      fill="white"
    />
    {/* Top-right corner - arrow pointing to bottom-right */}
    <rect
      x="27.5"
      y="4"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M32.3077 7.39348C31.9172 7.00295 31.284 7.00295 30.8935 7.39348C30.503 7.784 30.503 8.41717 30.8935 8.80769L32.3077 7.39348ZM41.5001 19.0001C42.0524 19.0001 42.5001 18.5524 42.5001 18.0001L42.5001 9.00008C42.5001 8.4478 42.0524 8.00008 41.5001 8.00008C40.9478 8.00008 40.5001 8.4478 40.5001 9.00008L40.5001 17.0001L32.5001 17.0001C31.9478 17.0001 31.5001 17.4478 31.5001 18.0001C31.5001 18.5524 31.9478 19.0001 32.5001 19.0001L41.5001 19.0001ZM31.6006 8.10059L30.8935 8.80769L40.793 18.7072L41.5001 18.0001L42.2072 17.293L32.3077 7.39348L31.6006 8.10059Z"
      fill="white"
    />
    {/* Bottom-left corner - arrow pointing to bottom-right */}
    <rect
      x="4.5"
      y="26"
      width="19"
      height="18"
      rx="5"
      fill="currentColor"
      fillOpacity="0.36"
    />
    <path
      d="M9.30769 29.3935C8.91717 29.003 8.284 29.003 7.89348 29.3935C7.50295 29.784 7.50295 30.4172 7.89348 30.8077L9.30769 29.3935ZM18.5001 41.0001C19.0524 41.0001 19.5001 40.5524 19.5001 40.0001L19.5001 31.0001C19.5001 30.4478 19.0524 30.0001 18.5001 30.0001C17.9478 30.0001 17.5001 30.4478 17.5001 31.0001L17.5001 39.0001L9.50008 39.0001C8.9478 39.0001 8.50008 39.4478 8.50008 40.0001C8.50008 40.5524 8.9478 41.0001 9.50008 41.0001L18.5001 41.0001ZM8.60059 30.1006L7.89348 30.8077L17.793 40.7072L18.5001 40.0001L19.2072 39.293L9.30769 29.3935L8.60059 30.1006Z"
      fill="white"
    />
    {/* Bottom-right corner highlighted (orange) */}
    <rect x="27.5" y="26" width="19" height="18" rx="5" fill="currentColor" />
  </g>
);
